import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useSingleNews } from '../../api/hooks/use.news'
import { IShortNews, newsService } from '../../api/service/news.service'

import { HeadingComponent } from '../../components/ui/heading.component'
import LoaderComponent from '../../components/ui/loader.component'
import ArrRight from '../../styles/icons/arr-right.svg'
import * as styled from './styled'

function SingleNewsPage() {
	const location = useLocation()
	const { id } = useParams<{ id: string }>()

	const { data: responseData, isLoading } = useSingleNews(Number(id))

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [location])

	const newsItem = responseData?.news
	const similarNews = responseData?.similarNews || []

	return (
		<styled.SingleNewsPageContainer>
			<HeadingComponent
				title={<>Новини</>}
				description='На цій сторінці розміщується оперативна інформація про роботу Контакт-Центру, виконання важливих міських робіт, попередження про аварійні ситуації та інші корисні повідомлення для мешканців'
				breadcrumbs={[
					{ title: 'Головна', path: '/' },
					{ title: 'Новини', path: '/news' },
				]}
			/>

			<styled.SingleNewsPageBody>
				{isLoading ? (
					<LoaderComponent />
				) : (
					<>
						<styled.SingleNewsContentArea>
							<styled.SingleNewsSection>
								{newsItem?.headerImgId && (
									<styled.SinglePageMainImg
										src={newsService.getImageUrl(newsItem.headerImgId)}
										alt='main-img'
									/>
								)}
								<styled.SingleNewsSectionBody>
									<styled.NewsDate>{newsItem?.createDate}</styled.NewsDate>
									<styled.SectionTitle>{newsItem?.titleUa}</styled.SectionTitle>
									<styled.SectionText
										dangerouslySetInnerHTML={{ __html: newsItem?.textUa || '' }}
									/>
								</styled.SingleNewsSectionBody>
							</styled.SingleNewsSection>
						</styled.SingleNewsContentArea>
						<styled.NewsSidebar>
							<styled.NewsSidebarHeader to={`/news`}>
								<styled.SidebarHeaderTitle>
									Інші новини
								</styled.SidebarHeaderTitle>
								<styled.SidebarHeaderIcon src={ArrRight} alt='arr-icon' />
							</styled.NewsSidebarHeader>

							<styled.SidebarNewsListContainer>
								{similarNews.map((item: IShortNews) => (
									<styled.SidebarNewsItem key={item.id}>
										<styled.NewsDate>{item.createDate}</styled.NewsDate>
										<styled.SidebarNewsTitle to={`/news/${item.id}`}>
											{item.titleUa}
										</styled.SidebarNewsTitle>
									</styled.SidebarNewsItem>
								))}
							</styled.SidebarNewsListContainer>
						</styled.NewsSidebar>
					</>
				)}
			</styled.SingleNewsPageBody>
		</styled.SingleNewsPageContainer>
	)
}

export default SingleNewsPage
